import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { getUserInfo } from '@modusign/openapi-client-user';

import authService from '@app/libs/auth/authService';
import { activateLogger, logger, setLoggerUser } from '@app/libs/datadog/logger';
import { activateMonitoring, setRumUser } from '@app/libs/datadog/monitoring';
import workspaceService from '@app/libs/workspaceService';

export { logger } from '@app/libs/datadog/logger';

export function activateDatadog() {
  if (process.env.REACT_APP_TENANT_ENV !== 'modusign-gov') {
    activateLogger();
    activateMonitoring();
  }
}

export function setDatadogUser() {
  if (
    // TODO(@highcastlee): refreshToken 정상 도입 후 refreshToken 만료만 확인하도록 수정합니다.
    authService.hasRefreshToken()
      ? !authService.isRefreshTokenExpired()
      : !authService.isAccessTokenExpired()
  ) {
    const sub = authService.getSub();

    const id = sub || 'undefined';
    setLoggerUser({ id });
    setRumUser({ id });

    getUserInfo()
      .then((data) => {
        setLoggerUser({
          id,
          email: data.profile.email,
          name: data.profile.name,
        });
        setRumUser({
          id,
          email: data.profile.email,
          name: data.profile.name,
        });
      })
      .catch((error) => logger.error('Datadog rum user setup failed', { sub }, error));

    if (workspaceService.hasWorkspaceId()) {
      setDatadogContextProperty('workspaceId', workspaceService.getWorkspaceId());
    }
  } else {
    setLoggerUser(null);
    setRumUser(null);
  }
}

// 회원가입하지 않은 유저의 경우 프로필이 없어서 유저 정보를 설정할 수 없습니다.
// 서버에서도 이 경우 프로필을 따로 설정하지 않아서 클라이언트에서만 설정합니다.
// FIXME: 추후 서버에서도 클라이언트와 맞추어서 링크 유저 맥락을 설정해야합니다.
// 그 때 서버에서도 meta가 아니라 user에 프로필을 설정하도록 수정한 후 클라이언트에서도 meta에 별도로 유저 프로필 설정하는 코드를 제거해볼 수 있겠습니다.
export function setDatadogContextForContractProgress(data: {
  contact: string;
  participantId: string;
  documentId: string;
}) {
  datadogLogs.setUser({
    ...datadogLogs.getUser(),
    participant: {
      contact: data.contact,
      id: data.participantId,
    },
  });
  datadogRum.setUser({
    ...datadogRum.getUser(),
    participant: {
      contact: data.contact,
      id: data.participantId,
    },
  });

  setDatadogContextProperty('documentId', data.documentId);
}

export function setDatadogContextProperty(key: string, value: unknown) {
  datadogRum.setGlobalContextProperty(key, value);
  datadogLogs.setGlobalContextProperty(key, value);
}
